module.exports = __webpack_public_path__ + "img/aigenerate.135efc17.svg";